import { render, staticRenderFns } from "./InjuriesBlock.vue?vue&type=template&id=61d2dcd6&lang=pug&"
import script from "./InjuriesBlock.vue?vue&type=script&lang=js&"
export * from "./InjuriesBlock.vue?vue&type=script&lang=js&"
import style0 from "./InjuriesBlock.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports